import React from 'react';

/**
 * Checks whether the autotest query param is present in the current URL.
 * @returns boolean
 */
export const useIsAutoTestEnabled = () =>
    React.useMemo(() => new URLSearchParams(window.location.search).has('autotest'), []);
